import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    super('wallet', {});
  }

  async setupEvents() {
    this.on(constants.EVENTS.WALLET.REFRESHED, (data) => {
      if (!data.userId) return;
      this.state[data.userId] = {
        loading: false,
        balance: data.balance,
        error: null
      };
    });

    this.on(constants.EVENTS.WALLET.REFRESH_ERROR, (data) => {
      if (!data.userId) return;
      this.state[data.userId] = {
        loading: false,
        balance: '-',
        error: data?.message || data
      };
    });

    this.on(constants.EVENTS.WALLET.REFRESHING, (data) => {
      if (!data.userId) return;
      this.state[data.userId] = {
        loading: true,
        balance: '-',
        error: null
      };
      this.updateState({ loading: true });
    });
  }
}

// new Store();
export default Store;
